import { getConferenceState } from '../../../react/features/base/conference/functions';
import { MEDIA_TYPE } from '../../../react/features/base/media/constants';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { isLocalTrackMuted } from '../../../react/features/base/tracks/functions.any';
import { sendKinesisEvent } from './kinesis/actions';
StateListenerRegistry.register(
/* selector */ state => isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.AUDIO), 
/* listener */ (muted, { dispatch, getState }, prevMuted) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    if (typeof prevMuted === 'undefined' || !conference) {
        return;
    }
    dispatch(sendKinesisEvent({
        message: `audio ${muted ? 'muted' : 'unmuted'}`
    }));
});
StateListenerRegistry.register(
/* selector */ state => isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.VIDEO), 
/* listener */ (muted, { dispatch, getState }, prevMuted) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    if (typeof prevMuted === 'undefined' && !conference) {
        return;
    }
    dispatch(sendKinesisEvent({
        message: `video ${muted ? 'muted' : 'unmuted'}`
    }));
});
